export default "__VITE_ASSET__COMMCKKR__"